<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{this.$t('page.product-info.text')}}</h4>
        </div>
        <div class="card-body">
          <div v-show="$route.query.type != 'edit'" class="col-3">
            <span class="must-input">* </span>
            <label class="form-label">{{this.$t('page.product-info.type')}}</label>
            <Multiselect
              :class="[isCheckForm]"
              v-model="current_type"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :options="[
                { label: this.$t('page.work-order.device.single'), value: 1 },
                { label: this.$t('page.work-order.device.unit_type'), value: 2 },
              ]"
              :disabled="$route.query.type == 'edit'"
            />
          </div>
          <div class="col-3 mt-2">
            <span class="must-input">* </span>
            <label class="form-label">{{this.$t('page.product-info.name')}}</label>
            <!--
            <Multiselect
              :class="[isCheckForm && !objModel && 'is-invalid']"
              v-model="objModel"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :options="
                objModelInfo.map((info) => {
                  return info.name;
                })
              "
              :disabled="$route.query.type == 'edit'"
            />
            -->
            <el-cascader
              v-if="$route.query.type != 'edit'"
              :class="[
                submitted && parentNode.node.length <= 0 && 'is-invalid',
              ]"
              ref="cascaderPanelRef"
              style="width: 100%"
              v-model="value"
              :options="objModelInfo"
              :props="setProps"
              :show-all-levels="true"
              :clearable="true"
              :size="'large'"
              :filterable="true"
              :disabled="$route.query.type == 'edit'"
              :placeholder="this.$t('page.product-info.select')"
              @change="selectedObj"
            />

            <input
              v-show="$route.query.type == 'edit'"
              v-model="objModel"
              :disabled="$route.query.type == 'edit'"
              type="text"
              class="form-control"
            />
          </div>

          <div class="must-input" v-show="isCheckForm && !objModel">
            {{this.$t('page.product-info.model_name_cannot_be_null')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import the component
// import Treeselect from "vue3-treeselect";
// import the styles
import "vue3-treeselect/dist/vue3-treeselect.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import _ from "loadsh";
export default {
  data() {
    return {
      current_type: null,
      objModel: null,
      value: null,
      setProps: {
        checkStrictly: true,
        expandTrigger: "hover",
        value: "id",
        label: "name",
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children:
            node.children && node.children.length > 0 ? node.children : 0,
        };
      },
    };
  },
  emits: [
    "update:selectedObjModel",
    "selectedCurrentType",
    "selectedObjModelIds",
  ],
  props: {
    isCheckForm: {
      type: Boolean,
      default: false,
    },
    selectedObjModel: {
      type: String,
      default: "",
    },
    objModelInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    selectedObjModel: {
      handler(val) {
        this.objModel = val;
      },
      deep: true,
    },
    objModel: {
      handler(val) {
        console.log(val);
        this.$emit("update:selectedObjModel", val);
      },
      deep: true,
    },
    current_type: {
      handler(val) {
        console.log(val);
        this.$emit("selectedCurrentType", val);
      },
      deep: true,
    },
  },
  methods: {
    selectedObj(e) {
      this.$refs.cascaderPanelRef.togglePopperVisible();
      var product_list = [];
      let queue = _.cloneDeep(this.objModelInfo);
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          e.map((a) => {
            if (child.id == a) {
              product_list.push(child.name);
            }
          });
          child.children && queue.push(...child.children);
        });
      }
      this.$emit("selectedObjModelIds",e[e.length-1],product_list)
    },
  },
  components: {
    Multiselect,
    // Treeselect,
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-cascader .el-input__wrapper) {
  &.is-focus {
    box-shadow: 0 0 0 1px #a0a8c4 inset !important;
    border-radius: 4px!important;
  }
}
</style>
